import { computed } from 'vue'
import type { SmartStore, IQuestionnaireStore } from '~/features/QuestionnaireUtils'

export enum PROCESS_STATES {
  DONE = 'done',
  PROCESSING = 'processing'
}

export const getStateFromBoolean = (state: boolean): PROCESS_STATES => {
  return state ? PROCESS_STATES.PROCESSING : PROCESS_STATES.DONE
}

export const hasPendingRequests = (store: SmartStore<IQuestionnaireStore>) => {
  return computed(() => store.state.activeRequests.length !== 0)
}

export const hasScheduledRequests = (store: SmartStore<IQuestionnaireStore>) => {
  return computed(() => store.state.scheduledRequests.length !== 0)
}

export const isSidekiqDone = (store: SmartStore<IQuestionnaireStore>) => {
  return computed(() => store.getters.sidekiq_done)
}
